"use strict";
/* eslint-disable no-redeclare */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.range = void 0;
function range(stopOrStart, stop) {
    if (stop == null) {
        // stopOrStart is stop
        return __spreadArray([], __read(Array(stopOrStart).keys()), false);
    }
    // stopOrStart is start
    if (stop <= stopOrStart) {
        return [];
    }
    return __spreadArray([], __read(Array(stop - stopOrStart).keys()), false).map(function (num) { return num + stopOrStart; });
}
exports.range = range;
